import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTaskTickOutline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 20 21",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10 3.976a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13Zm0 14.5a8 8 0 0 0 8-8 8 8 0 0 0-8-8 8 8 0 0 0-8 8 8 8 0 0 0 8 8Zm2.638-9.353a.75.75 0 0 0-1.272-.797l-1.919 3.072-.844-1.125a.75.75 0 1 0-1.2.9l1.5 2c.147.197.385.31.631.3a.74.74 0 0 0 .604-.353l2.5-4v.003Z" })
});
export default SvgTaskTickOutline;
